import React, { useMemo } from 'react';
import { HStack, StackDivider, Button } from '@chakra-ui/react'
import { MdCall, MdSend  } from 'react-icons/md';
import { AiFillFacebook, AiFillHeart, AiOutlineHeart, AiFillStar, AiOutlineStar } from 'react-icons/ai';
import { useUser, useGlobal } from 'src/context'
import { trackEvent } from 'utils';

const GameActions = props => {
  const { onOpenReview, isLoadingReview, isGameOver, gameId, title, rsvLink, rsvCall } = props;
  const { onOpenLogin } = useGlobal();
  const { 
    isLogin,
    isLoadingUser,
    isPostingReview,
    user: { 
      likeGamesIdList, reviewedGamesIdList
    },
    updateList
  } = useUser();

  const hasLike = useMemo(() => {
    return likeGamesIdList.includes(gameId);
  }, [likeGamesIdList, gameId]);

  const hasReviewed = useMemo(() => {
    return reviewedGamesIdList.includes(gameId);
  }, [reviewedGamesIdList, gameId]);

  const handleLikeToggle = () => {
    trackEvent({
      category: 'Like--GamePage',
      action: 'Click',
      label: `${gameId}-${title}`,
    });

    if (isLogin) {
      updateList('like', gameId)
    } else {
      if (!isLoadingUser) onOpenLogin();
    };
  };

  const handleReviewClick = () => {
    if (isLogin) {
      onOpenReview();
    } else {
      if (!isLoadingUser) onOpenLogin();
    }
  };

  return (
    <HStack 
      as='aside' 
      divider={<StackDivider borderColor='gray.200' />}
      justify='space-between'
      py={3}
      bg='white'
      rounded='base'
    >
      <GameLikeBlock
        isLoading={isLoadingReview || isLoadingUser || isPostingReview}
        hasLike={hasLike}
        hasReviewed={hasReviewed}
        onToggle={handleLikeToggle}
        onOpen={handleReviewClick}
      />
      {(!isGameOver && (rsvLink || rsvCall)) && (
        <ActionBlock {...props} />
      )}
    </HStack>
  );
}

const GameLikeBlock = props => {
  const { isLoading, hasLike, hasReviewed, onToggle, onOpen } = props;

  return (
    <HStack spacing={3}>
      <Button 
        variant='ghost'
        size='sm'
        leftIcon={hasLike ? <AiFillHeart /> : <AiOutlineHeart />} 
        colorScheme='primary'
        onClick={onToggle}
        isDisabled={isLoading}
      >
        收藏
      </Button>
      <Button 
        variant='ghost'
        size='sm'
        leftIcon={hasReviewed ? <AiFillStar /> : <AiOutlineStar />} 
        colorScheme='secondary'
        onClick={onOpen}
        isDisabled={isLoading}
      >
        評價
      </Button>
    </HStack>
  )
};

const ActionBlock = props => {
  const { rsvLink, rsvCall, gameId, title } = props;

  const handleRsvLinkClick = () => {
    trackEvent({
      category: "Reservation",
      action: "Click",
      label: `${gameId}-${title}-${rsvLink}`,
      value: 2,
    });
  };

  const handleRsvCallClick = () => {
    trackEvent({
      category: "Reservation",
      action: "Call",
      label: `${gameId}-${title}-${rsvCall}`,
      value: 10,
    });
  }

  const isToFacebook = rsvLink && rsvLink.includes('facebook');
  const sanitizedRsvLink = rsvLink + (rsvLink.includes('?') ? '&' : '?') + 'utm_source=EscapeBar&utm_medium=referral&utm_campaign=EscapeBarGamePage';

    return (
      <HStack spacing={3}>
        {rsvLink && rsvLink.length > 0 && (
          <a href={sanitizedRsvLink} target="_blank">
            <Button 
              variant='ghost'
              size='sm'
              leftIcon={isToFacebook ? <AiFillFacebook/> : <MdSend />} 
              colorScheme={isToFacebook ? 'facebook' : 'primary'} 
              onClick={handleRsvLinkClick}
            >
              預約
            </Button>
          </a>
        )}

        {rsvCall && rsvCall.length > 0 && (  
          <a href={`tel:${rsvCall}`}>
            <Button 
              variant='ghost'
              size='sm'
              leftIcon={<MdCall />} 
              colorScheme='primary' 
              onClick={handleRsvCallClick}
            >
              致電
            </Button>
          </a>
        )}
      </HStack>
    );
};

export default GameActions;